import React, { useContext, useState, useEffect } from "react";
import Logo from "../../images/logo.webp";
import { MdDarkMode, MdOutlineLightMode } from "react-icons/md";
import { HiBars3, HiHome, HiInformationCircle, HiBookOpen, HiEnvelope } from "react-icons/hi2";
import { IoClose } from "react-icons/io5";
import { FaGooglePlay } from "react-icons/fa6";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";
import "./navBar.css";
import { WebsiteContext } from "../../context/AppContext";

const navItems = [
  { label: "Home", route: "Home", path: "/", icon: <HiHome size={18} /> },
  { label: "About", route: "About", path: "/about_us", icon: <HiInformationCircle size={18} /> },
  { label: "Blog", route: "Blog", path: "/blogs", icon: <HiBookOpen size={18} /> },
  { label: "Contact", route: "Contact", path: "/contact", icon: <HiEnvelope size={18} /> },
];

const NavBarComponent = () => {
  const { dark, handleThemeMode, color, handleRoute, isMobileView } = useContext(WebsiteContext);
  const [modalMenu, setModalMenu] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (modalMenu) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [modalMenu]);

  const handleMobileClick = (routeType) => {
    handleRoute(routeType);
    setModalMenu(false);
  };

  const isActive = (path) => {
    if (path === "/" && location.pathname === "/") return true;
    if (path !== "/" && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <header className={`navbar_header_wrapper ${dark ? "navbar_wrapper_dark" : "navbar_wrapper_light"}`}>
      <div className="navbar_inner_container">
        {/* Brand / Logo */}
        <div className="navbar_brand" onClick={() => handleRoute("Home")}>
          <img src={Logo} alt="Fluent Fable Logo" className="navbar_brand_logo" />
          <span className="navbar_brand_text">Fluent Fable</span>
        </div>

        {/* Desktop View */}
        {!isMobileView ? (
          <>
            <nav className="navbar_links_group">
              {navItems.map((item) => {
                const active = isActive(item.path);
                return (
                  <div
                    key={item.route}
                    className={`nav_link_item ${active ? "nav_link_active" : ""}`}
                    style={{ color: color }}
                    onClick={() => handleRoute(item.route)}
                  >
                    {item.label}
                  </div>
                );
              })}
            </nav>

            <div className="navbar_actions_right">
              {/* Theme Toggle */}
              <button
                className="theme_toggle_btn"
                onClick={handleThemeMode}
                title={dark ? "Switch to Light Mode" : "Switch to Dark Mode"}
                style={{ color: color }}
              >
                {dark ? <MdOutlineLightMode size={22} color="#f8fafc" /> : <MdDarkMode size={22} color="#0f172a" />}
              </button>

              {/* Get The App CTA */}
              <button
                className="navbar_cta_btn"
                onClick={() => handleRoute("GettheApp")}
              >
                <FaGooglePlay size={15} />
                <span>Get the App</span>
              </button>
            </div>
          </>
        ) : (
          /* Mobile Hamburger & Actions */
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <button
              className="theme_toggle_btn"
              onClick={handleThemeMode}
              style={{ color: color }}
            >
              {dark ? <MdOutlineLightMode size={20} color="#f8fafc" /> : <MdDarkMode size={20} color="#0f172a" />}
            </button>

            <button
              className="mobile_menu_trigger"
              onClick={() => setModalMenu(!modalMenu)}
              style={{ color: color }}
              aria-label="Toggle Navigation"
            >
              <HiBars3 size={26} color={dark ? "#f8fafc" : "#0f172a"} />
            </button>
          </div>
        )}
      </div>

      {/* Mobile Drawer */}
      <AnimatePresence>
        {isMobileView && modalMenu && (
          <motion.div
            initial={{ opacity: 0, x: "100%" }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: "100%" }}
            transition={{ type: "tween", duration: 0.28 }}
            className={`mobile_drawer_overlay ${dark ? "drawer_dark" : "drawer_light"}`}
          >
            {/* Drawer Top */}
            <div className="mobile_drawer_top">
              <div className="navbar_brand" onClick={() => handleMobileClick("Home")}>
                <img src={Logo} alt="Fluent Fable Logo" className="navbar_brand_logo" />
                <span className="navbar_brand_text">Fluent Fable</span>
              </div>
              <button
                className="mobile_menu_trigger"
                onClick={() => setModalMenu(false)}
                style={{ color: color }}
              >
                <IoClose size={26} color={dark ? "#f8fafc" : "#0f172a"} />
              </button>
            </div>

            {/* Drawer Navigation Links */}
            <div className="mobile_drawer_links">
              {navItems.map((item) => {
                const active = isActive(item.path);
                return (
                  <div
                    key={item.route}
                    className={`mobile_drawer_item ${active ? "mobile_drawer_active" : ""}`}
                    onClick={() => handleMobileClick(item.route)}
                  >
                    {item.icon}
                    <span>{item.label}</span>
                  </div>
                );
              })}
            </div>

            {/* Drawer Footer Actions */}
            <div className="mobile_drawer_footer">
              <div className="mobile_theme_row" onClick={handleThemeMode}>
                <span>Appearance Mode</span>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  {dark ? (
                    <>
                      <MdOutlineLightMode size={18} color="#f8fafc" />
                      <span>Dark</span>
                    </>
                  ) : (
                    <>
                      <MdDarkMode size={18} color="#0f172a" />
                      <span>Light</span>
                    </>
                  )}
                </div>
              </div>

              <button
                className="mobile_app_download_btn"
                onClick={() => handleMobileClick("GettheApp")}
              >
                <FaGooglePlay size={18} />
                <span>Download on Google Play</span>
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default NavBarComponent;
